module.exports = __webpack_public_path__ + "img/MELA_Mast.f9750a21.png";